import DownloadPdf from "./DownloadPdf";

export default DownloadPdf;
